<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>卡片集齐人数</span>
    </div>

    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="选择活动" prop="id">
        <el-select
          v-model="queryParams.id"
          clearable
          style="width: 380px;"
          placeholder="请选择"
          filterable
          @change="idChange"
          @visible-change="handleVisibleChange"
        >
          <el-option
            v-for="item in actArr"
            :key="item.value"
            :label="getActOptionLabel(item)"
            :value="item.value"
          />
          <el-option
            v-if="hasMoreAct"
            value=""
            disabled
            style="text-align: center; cursor: pointer;"
          >
            <span v-if="actLoading" style="color: #999;">加载中...</span>
            <span v-else style="color: #409EFF;" @click.stop="loadMoreAct">点击加载更多</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          :disabled="dateDisabled"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          :disabled="dateDisabled"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini" @click="handleQuery(false)">查询</el-button>
        <el-button icon="el-icon-download" size="mini" :loading="loading" @click="handleQuery(true)">导出</el-button>
      </el-form-item>
    </el-form>

    <template>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        show-summary
        :summary-method="getSummary"
      >
        <el-table-column
          prop="date"
          label="日期"
          align="center"
          width="120"
        />
        <el-table-column
          v-for="(item, index) in cardInfo"
          :key="index"
          :label="item.ci_name"
          align="center"
        >
          <el-table-column
            align="center"
            label="卡片数量"
          >
            <template slot-scope="{row}">
              <span v-if="row.data[item.ciid]">{{ row.data[item.ciid].count }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="用户数量"
          >
            <template slot-scope="{row}">
              <span v-if="row.data[item.ciid]">{{ row.data[item.ciid].user }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="人均数量"
          >
            <template slot-scope="{row}">
              <span v-if="row.data[item.ciid]">{{ row.data[item.ciid].avg }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </template>
  </el-card>
</template>
<script >
import { getCardInfoStat } from '@/api/config/card-stat'
import actList from '../mixins/actList.js'
import { getLastDates } from '@/utils/index.js'

export default {
  components: {
  },
  mixins: [actList],
  props: {
    selectedActId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dateDisabled: false,
      loading: false,
      tableData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: 0,
        id: ''
      },
      cardInfo: []
    }
  },
  watch: {
    selectedActId: {
      immediate: true,
      handler(val) {
        if (val !== undefined && val !== '') {
          this.syncActChange(val)
        }
      }
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
  },
  mounted() {
    this.loadActList()
  },
  methods: {
    getTables() {
      this.loading = true
      getCardInfoStat(this.queryParams).then(res => {
        this.loading = false
        if (this.queryParams.type > 0) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
        }
        const { data, cardInfo } = res.data
        this.cardInfo = cardInfo
        this.tableData = data
      })
    },
    handleQuery(isExport) {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.queryParams.type = 0
      if (isExport) {
        this.queryParams.type = 1
      }
      this.getTables()
    },
    idChange(event) {
      this.queryParams.startString = ''
      this.queryParams.endString = ''
      if (event !== '') {
        const dateRange = this.dateRange[event]
        const dateArr = dateRange.split('至')
        this.queryParams.startString = dateArr[0]
        this.queryParams.endString = dateArr[1]
      }
      this.dateDisabled = event !== ''
    },
    getActOptionLabel(item) {
      const actName = this.actNameMap[item.value] || ''
      const dateRange = this.dateRange[item.value] || item.label
      return actName ? `${actName} - ${dateRange}` : dateRange
    },
    syncActChange(actId) {
      this.queryParams.id = actId
      this.idChange(actId)
    },
    getSummary(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '汇总'
          return
        }
        const cardIndex = Math.floor((index - 1) / 3)
        const fieldType = (index - 1) % 3
        if (cardIndex >= this.cardInfo.length) {
          sums[index] = 0
          return
        }
        let total = 0
        for (const row of data) {
          const ciid = this.cardInfo[cardIndex].ciid
          const cardData = row.data[ciid]
          if (cardData) {
            if (fieldType === 0) {
              total += Number(cardData.count) || 0
            } else if (fieldType === 1) {
              total += Number(cardData.user) || 0
            }
          }
        }
        if (fieldType === 2) {
          const countSum = sums[index - 2] || 0
          const userSum = sums[index - 1] || 0
          sums[index] = userSum > 0 ? parseFloat((countSum / userSum).toFixed(2)) : 0
        } else {
          sums[index] = total
        }
      })
      return sums
    }
  }
}
</script>
<style scoped>

</style>
